import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";
import auth from "./auth";

import xior from 'xior';

themes.initialized(() => {
	const app = createApp(App);
	// Initialize our API link. This link is used for all REST calls except authentication, which is defined in auth.js.
	const $http = xior.create({
		baseURL: (appInfo.baseURL.endsWith('/') ? appInfo.baseURL.substr(0, appInfo.baseURL.length - 1) : appInfo.baseURL),
		headers: { 'Accept': 'application/json' },
	});
	app.provide('$http', $http);

	// Global 401 interceptor: if any API call returns 401 (token expired / revoked),
	// clear the session and redirect to login. This covers all views, not just /home.
	$http.interceptors.response.use(
		(result) => result,
		(error) => {
			if (error.response && error.response.status === 401) {
				auth.logOut();
				const currentPath = router.currentRoute.value.fullPath;
				// Avoid redirect loop if we're already on the login page.
				if (currentPath !== '/login-form') {
					router.push({ path: '/login-form', query: { redirect: currentPath } });
				}
			}
			return Promise.reject(error);
		}
	);

	// Give auth the $http reference before the router is installed,
	// so route guards can set the Authorization header correctly.
	auth.init($http);

	app.use(router);
	app.config.globalProperties.$appInfo = appInfo;
	app.mount('#app');
});
